"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.FeatureDemoHeader = () => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { className: "text-center" },
        react_1.default.createElement(react_2.OsmosysDiv, { className: "", flexRowCenteredFilled: true },
            react_1.default.createElement(react_2.OsmosysDiv, { className: "", flexColCentered: true },
                react_1.default.createElement(react_2.OsmosysLogo, { height: 40, marginRight: 2 })),
            react_1.default.createElement(react_2.OsmosysDiv, { className: "", flexColCentered: true },
                react_1.default.createElement("h1", { className: "display-2 my-0", style: { fontSize: 30 } }, "Osmosys Feature Demo")))));
};
//# sourceMappingURL=index.js.map